"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var ResponsiveHelper_1 = __importDefault(require("../ResponsiveHelper/ResponsiveHelper"));
var GridContext_1 = __importDefault(require("./GridContext"));
var react_1 = require("react");
var Row_1 = __importDefault(require("./Row/Row"));
var Column_1 = __importDefault(require("./Column/Column"));
/**
 * Grid systems are used for creating page layouts through a series of rows and columns that house content. The Grid component builds these layouts using a twelve-column system.
 * @child ./Row/Row.tsx
 * @child ./Column/Column.tsx
 */
var Grid = /** @class */ (function (_super) {
    __extends(Grid, _super);
    function Grid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.setContext = function (breakpoint) {
            _this.setState({ breakpoint: breakpoint });
        };
        return _this;
    }
    Grid.prototype.render = function () {
        var _a = this.props, className = _a.className, rest = __rest(_a, ["className"]);
        return (React.createElement(GridContext_1.default.Provider, { value: this.state },
            React.createElement("div", __assign({}, rest, { className: this.genGridClasses() }), this.props.children),
            React.createElement(ResponsiveHelper_1.default, { onBreakpoint: this.setContext })));
    };
    Grid.prototype.genGridClasses = function () {
        var classes = 'ui scuf-grid';
        if (this.props.className) {
            classes += " " + this.props.className;
        }
        if (this.state && this.state.breakpoint) {
            classes += " " + this.state.breakpoint.name;
        }
        return classes;
    };
    Grid.Row = Row_1.default;
    Grid.Column = Column_1.default;
    return Grid;
}(react_1.Component));
exports.default = Grid;
